import { NavigationItem } from "../navigation-item"
import { ActiveStateAnyStartsWithStrategy } from "../strategies/active-state-any-starts-with-strategy"
import { AnalyticsMoreSubItem } from "../subitems/analytics-more-subitem"
import { BlogMoreSubItem } from "../subitems/blog-more-subitem"
import { DiagnosticsMoreSubItem } from "../subitems/diagnostics-more-subitem"
import { DocsMoreSubItem } from "../subitems/docs-more-subitem"
import { TreasuryMoreSubItem } from "../subitems/treasury-more-subitem"

export class MoreNavigationItem extends NavigationItem {
  readonly id = "more"
  readonly label = "More..."
  readonly href = "/docs"
  readonly iconName = "more-icon"
  readonly isExternal = false

  readonly tabs = []
  readonly subItems = [
    // new ProtocolsMoreSubItem(),
    new DocsMoreSubItem(),
    new BlogMoreSubItem(),
    new AnalyticsMoreSubItem(),
    new TreasuryMoreSubItem(),
    new DiagnosticsMoreSubItem(),
  ]

  constructor() {
    super()

    this.subItems[2]?.setActiveStrategy(new ActiveStateAnyStartsWithStrategy(["/analytics"]))
    this.subItems[3]?.setActiveStrategy(new ActiveStateAnyStartsWithStrategy(["/treasury"]))
    this.subItems[4]?.setActiveStrategy(new ActiveStateAnyStartsWithStrategy(["/diagnostics"]))
  }
}
